import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../i18n/useLanguage';

export default function Footer() {
  const { t } = useTranslation();
  const { currentLanguage, changeLanguage } = useLanguage();

  return (
    <>
      {/* ===== App Download Banner ===== */}
      <div style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 60%, #0f3460 100%)',
        padding: '48px 0',
      }}>
        <div className="container hp-container">
          <div className="row align-items-center g-4">
            {/* Left: text + badges */}
            <div className="col-lg-7">
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                <div style={{
                  width: 48, height: 48, borderRadius: 12,
                  background: '#fe5a1d', display: 'flex', alignItems: 'center',
                  justifyContent: 'center', flexShrink: 0,
                }}>
                  <i className="bi bi-phone-fill" style={{ color: '#fff', fontSize: 22 }}></i>
                </div>
                <h2 style={{ color: '#fff', fontWeight: 800, fontSize: '1.7rem', margin: 0 }}>
                  {t('footer.app_title')} <span style={{ color: '#fe5a1d' }}>AutoPlace</span> App
                </h2>
              </div>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '1rem', maxWidth: 480, marginBottom: 28, lineHeight: 1.6 }}>
                {t('footer.app_subtitle')}
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
                {/* App Store badge */}
                <a
                  href="https://apps.apple.com/us/app/autoplace/id6753959493"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'flex', alignItems: 'center', gap: 10,
                    background: '#000', color: '#fff', padding: '10px 20px',
                    borderRadius: 12, textDecoration: 'none', minWidth: 160,
                    border: '1px solid rgba(255,255,255,0.15)',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                  onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <i className="bi bi-apple" style={{ fontSize: 28, lineHeight: 1 }}></i>
                  <div style={{ lineHeight: 1.2 }}>
                    <div style={{ fontSize: 10, opacity: 0.8 }}>{t('footer.download_on')}</div>
                    <div style={{ fontSize: 16, fontWeight: 700 }}>{t('footer.app_store')}</div>
                  </div>
                </a>
                {/* Google Play badge */}
                <a
                  href="https://play.google.com/store/apps/details?id=al.autoplace.app"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'flex', alignItems: 'center', gap: 10,
                    background: '#000', color: '#fff', padding: '10px 20px',
                    borderRadius: 12, textDecoration: 'none', minWidth: 160,
                    border: '1px solid rgba(255,255,255,0.15)',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                  onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <i className="bi bi-google-play" style={{ fontSize: 26, lineHeight: 1 }}></i>
                  <div style={{ lineHeight: 1.2 }}>
                    <div style={{ fontSize: 10, opacity: 0.8 }}>{t('footer.get_it_on')}</div>
                    <div style={{ fontSize: 16, fontWeight: 700 }}>{t('footer.google_play')}</div>
                  </div>
                </a>
              </div>
            </div>

            {/* Right: QR code */}
            <div className="col-lg-5 d-flex justify-content-center justify-content-lg-end">
              <div style={{ textAlign: 'center' }}>
                <div style={{
                  background: '#fff', padding: 12, borderRadius: 16,
                  display: 'inline-block', boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
                }}>
                  <img
                    src={`https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=https://autoplace.al/app&color=1a1a2e&bgcolor=ffffff`}
                    alt="Scan QR to download AutoPlace app"
                    width={140}
                    height={140}
                    style={{ display: 'block', borderRadius: 8 }}
                  />
                </div>
                <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '13px', marginTop: 12, marginBottom: 0 }}>
                  {t('footer.scan_qr')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="home-footer">
        <div className="container hp-container">
          <div className="row g-4">
            {/* Brand Column */}
            <div className="col-lg-4 col-md-6">
              <Link to="/" className="d-inline-block mb-4">
                <h2 className="text-white fw-bold m-0" style={{ fontSize: '1.8rem' }}>Auto<span style={{ color: '#fe5a1d' }}>Place</span></h2>
              </Link>
              <p className="mb-4" style={{ maxWidth: '300px' }}>
                {t('footer.tagline')}
              </p>

              <div className="d-flex gap-2">
                <a href="https://facebook.com" className="footer-social-link" aria-label="Facebook">
                  <i className="bi bi-facebook"></i>
                </a>
                <a href="https://twitter.com" className="footer-social-link" aria-label="Twitter">
                  <i className="bi bi-twitter"></i>
                </a>
                <a href="https://instagram.com" className="footer-social-link" aria-label="Instagram">
                  <i className="bi bi-instagram"></i>
                </a>
                <a href="https://linkedin.com" className="footer-social-link" aria-label="LinkedIn">
                  <i className="bi bi-linkedin"></i>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-3 col-6">
              <h3>{t('footer.company_title')}</h3>
              <ul>
                <li><Link to="/about-us">{t('footer.about_us')}</Link></li>
                <li><Link to="/contact-us">{t('footer.contact_us')}</Link></li>
                <li><Link to="/privacy-policy">{t('footer.privacy_policy')}</Link></li>
                <li><Link to="/terms-and-conditions">{t('footer.terms')}</Link></li>
              </ul>
            </div>

            {/* Dealer Links */}
            <div className="col-lg-2 col-md-3 col-6">
              <h3>{t('footer.dealers_title')}</h3>
              <ul>
                <li><Link to="/dealer-register">{t('footer.dealer_registration')}</Link></li>
                <li><Link to="/login">{t('footer.dealer_login')}</Link></li>
                <li><Link to="/support">{t('footer.dealer_support')}</Link></li>
              </ul>
            </div>

            {/* Support / Contact */}
            <div className="col-lg-4 col-md-12">
              <h3>{t('footer.contact_title')}</h3>
              <ul className="list-unstyled">
                <li className="d-flex align-items-start mb-3">
                  <i className="bi bi-geo-alt me-2 mt-1 py-1" style={{ color: '#fe5a1d' }}></i>
                  <span style={{ color: '#aaaaaa' }}>
                    20 Wenlock Road, London,<br />
                    England, N1 7GU
                  </span>
                </li>
                <li className="d-flex align-items-center mb-3">
                  <i className="bi bi-envelope me-2" style={{ color: '#fe5a1d' }}></i>
                  <a href="mailto:support@autoplace.al">support@autoplace.al</a>
                </li>
                <li className="d-flex align-items-center">
                  <i className="bi bi-telephone me-2" style={{ color: '#fe5a1d' }}></i>
                  <a href="tel:+447418602800">+44 741 860 2800</a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Footer */}
          <div className="home-footer-bottom d-flex flex-column flex-md-row justify-content-between align-items-center">
            <p className="mb-2 mb-md-0">
              {t('footer.copyright')}
            </p>
            <div className="d-flex gap-3">
              <select
                className="form-select-dark"
                aria-label="Language selector"
                value={currentLanguage}
                onChange={e => changeLanguage(e.target.value)}
                style={{
                  background: '#1a1a2e',
                  color: '#ffffff',
                  border: '1px solid rgba(255,255,255,0.4)',
                  borderRadius: '6px',
                  padding: '4px 8px',
                  fontSize: '14px',
                  cursor: 'pointer',
                }}
              >
                <option value="en" style={{ background: '#1a1a2e', color: '#fff' }}>🇬🇧 English</option>
                <option value="sq" style={{ background: '#1a1a2e', color: '#fff' }}>🇦🇱 Shqip</option>
              </select>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
